import request from "../../utils/request";
import { Result } from "../../models/general";

// ..\mowazaf\Data\General\View Models\AppVersionViewModels.cs
export interface AppVersionPolicyView {
  id: number;
  platform: string;
  minVersion: string;
  latestVersion: string;
  forceUpdate: boolean;
  message?: string | null;
  storeUrl?: string | null;
  updatedOn?: string | null;
}

export interface AppVersionUpdateInput {
  platform: string;
  minVersion: string;
  latestVersion: string;
  forceUpdate: boolean;
  message?: string | null;
  storeUrl?: string | null;
}

/** Operator: read every platform's mobile-app version policy. */
export async function getAppVersionPolicies() {
  const res = await request.get<Result<AppVersionPolicyView[]>>(`AppVersion/all`);
  return res.data;
}

/** Operator: update a single platform's policy. */
export async function updateAppVersionPolicy(input: AppVersionUpdateInput) {
  const res = await request.put<Result<AppVersionPolicyView>>(`AppVersion`, input);
  return res.data;
}
